import { useSelector } from 'react-redux';
import { navSelector } from 'common/store/modules/competition-nav/selectors';
import {
    useGetCompetitionsQuery,
    useGetCompSeasonsQuery
} from 'store/modules/api/afl-api';

/**
 * @param nav
 * @returns {{
 *    competitions: object,
 *    seasons: object,
 *    rounds: object
 * }}
 */
export const useCompetitionNavigationOptions = (nav) => {
    const defaultSelector = useSelector(navSelector);
    const navObj = nav || defaultSelector;

    // Get comps from RTK
    const { data: competitions } = useGetCompetitionsQuery();

    const { seasons, rounds } = navObj;

    // If we don't have seasons in the state, request them
    const { data: seasonsData } = useGetCompSeasonsQuery(
        {
            competitionId: navObj.competition.id
        },
        { skip: !nav?.competition?.id || seasons?.length }
    );

    return { competitions, seasons: seasons ? seasons : seasonsData, rounds };
};
